import { render, staticRenderFns } from "./PropertyDetailView.vue?vue&type=template&id=f53ba780&scoped=true&"
import script from "./PropertyDetailView.vue?vue&type=script&lang=ts&"
export * from "./PropertyDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53ba780",
  null
  
)

export default component.exports